// extracted by mini-css-extract-plugin
module.exports = {"sunny_header":"header_sunny_header__3L4jf","headerFixed":"header_headerFixed__3dNeQ"};